import { render, staticRenderFns } from "./Product-DTx.vue?vue&type=template&id=140b7027&scoped=true"
import script from "./Product-DTx.vue?vue&type=script&lang=js"
export * from "./Product-DTx.vue?vue&type=script&lang=js"
import style0 from "./Product-DTx.vue?vue&type=style&index=0&id=140b7027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b7027",
  null
  
)

export default component.exports